export const SHIPPER_PARTNER_RESULTS_KEY = "shipper_signup_partner_invite_results";

export type PartnerInviteResult = {
  name: string;
  email: string;
  status: "added" | "invited" | "invite_failed" | "error";
};

export function classifyPartnerInviteResponse(
  responseOk: boolean,
  status: unknown,
): PartnerInviteResult["status"] {
  if (!responseOk) return "error";
  return status === "added" || status === "invited" || status === "invite_failed"
    ? status
    : "error";
}